<template>
  <div id="app">
    <div v-if="!loading">
      <router-view />
    </div>
    <div class="splash active" v-if="loading">
      <div class="splash-icon">
        <logo type="light" class="logo" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.fetch();
  },

  data() {
    return {
      loading: true,
    };
  },

  methods: {
    fetch() {
      this.loading = true

      this.$axios.get('/api/v1/init').then((response) => {
        if(response.data.auth) {
          this.$store.dispatch('setAuthUser', response.data.auth)
        } else {
          if(this.$storage.has('token')) {
            this.$storage.remove('token')
            window.location.reload(true)
          }
        }
        this.loading = false
      })
    },
  },
};
</script>
